import React from 'react'
import TechnologyTemplate from '../../templates/Technology/TechnologyTemplate'

const Technology = () => {
  return (
     <TechnologyTemplate />
  )
}

export default Technology